exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formCard[data-v-733cc3fe]{border:none!important;padding:0}.modal fade show d-block[data-v-733cc3fe]{background:none}.tab-list[data-v-733cc3fe]{display:flex;cursor:pointer;overflow-x:auto}.tab-list div[data-v-733cc3fe]{padding:10px;margin:5px;border:1px solid #ccc;border-radius:5px;white-space:nowrap;user-select:none;transition:background-color .3s}.tab-list div[data-v-733cc3fe]:hover{background-color:#0aa46e}.active-tab[data-v-733cc3fe]{background-color:#007bff;color:#fff}.tab-content[data-v-733cc3fe]{margin-top:10px}.fade-enter-active[data-v-733cc3fe],.fade-leave-active[data-v-733cc3fe]{transition:opacity .5s}.fade-enter[data-v-733cc3fe],.fade-leave-to[data-v-733cc3fe]{opacity:0}.custom-slide-enter-active[data-v-733cc3fe],.custom-slide-leave-active[data-v-733cc3fe]{transition:transform .5s}.custom-slide-enter[data-v-733cc3fe],.custom-slide-leave-to[data-v-733cc3fe]{transform:translateX(100%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-733cc3fe","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ulip/Tab.vue
// module id = 1702
// module chunks = 0